var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 56,
    viewBox: "0 0 53 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5964 3.90337L12.248 29.773L15.7231 29.7897C15.919 29.7897 16.1987 29.4204 16.2771 29.2357L18.6609 23.3769C18.8355 22.9471 19.0806 22.8285 19.1813 22.8229H24.9562C25.4766 22.8229 25.8795 22.3025 25.9803 22.2018L45.4538 3.50047H24.1168C23.8348 3.48704 23.6524 3.76348 23.5964 3.90337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2485 24.1435L19.051 24.6662L8.04395 52.5007L38.1366 23.5703H19.9066C19.5644 23.5838 19.3252 23.9581 19.2485 24.1435Z",
    fill: "white",
    fillOpacity: 0.941176
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/whiteLogo.ca5b81270e7a8f77ad68ea5863632b4f.svg";
export { ForwardRef as ReactComponent };